import { render } from "./ceremony.vue?vue&type=template&id=2c29a225&scoped=true"
import script from "./ceremony.vue?vue&type=script&lang=js"
export * from "./ceremony.vue?vue&type=script&lang=js"

import "./ceremony.vue?vue&type=style&index=0&id=2c29a225&lang=scss&scoped=true"
import "./ceremony.vue?vue&type=style&index=1&id=2c29a225&lang=scss"
script.render = render
script.__scopeId = "data-v-2c29a225"

export default script